<template>
    <div class="h-screen flex w-full">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto">
            <vx-card>
                <vs-row class="p-0" slot="no-body">
                    <vs-col class="text-center p-0 login-side-image" vs-xs="12" vs-sm="6" vs-lg="6">
                    </vs-col>

                    <vs-col class="p-base" vs-xs="12" vs-sm="6" vs-lg="6">
                        <vs-row>
                            <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                                <img :src="logo" class="login-logo mx-auto" />
                            </vs-col>
                          <!-- <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
                            <h6 class="text-center mt-0 mb-0">Project Name will come here</h6>
                          </vs-col> -->

                          <vs-col class="mt-2">
                            <h3 class="mt-2">Login</h3>
                          </vs-col>
                            <vs-col>
                                <vs-input
                                    v-model="email"
                                    type="Email"
                                    label="Email*"
                                    placeholder="Enter here"
                                    class="w-full mb-3"
                                    :danger="api_errors.email ? true : false"
                                    :danger-text="api_errors.email ? api_errors.email.join(',') : null"
                                    @keydown="(e) => {e.keyCode == 13 ? submit() : null}"
                                    :disabled="submit_disabled"
                                />
                            </vs-col>
                            <vs-col class="mb-3">
                                <vs-input
                                    v-model="password"
                                    type="Password"
                                    label="Password*"
                                    placeholder="Enter here"
                                    class="w-full"
                                    :danger="api_errors.password ? true : false"
                                    :danger-text="api_errors.password ? api_errors.password.join(',') : null"
                                    @keydown="(e) => {e.keyCode == 13 ? submit() : null}"
                                    :disabled="submit_disabled"
                                />
                                <small class="mt-2" style="display: block;">
                                    <router-link :to="{name: 'forgot-password'}">
                                        Forgot your password?
                                    </router-link>
                                </small>
                            </vs-col>
                            <vs-col class="mt-3">
                                <vs-button
                                    :disabled="submit_disabled"
                                    @click.prevent="submit"
                                style="width: 140px">
                                    Submit
                                </vs-button>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </vx-card>
            <div class="text-center mt-3">
                <small>v{{ $store.state.version }}</small>
            </div>
        </div>
    </div>
</template>

<script>
import { Request } from '../../utils/requests'

export default {
    data () {
        return {
            email: null,
            password: null,

            submit_disabled: false,
            api_errors: {}
        }
    },
    computed: {
        logo () {
            return require('@/assets/images/logo/logo.png')
        }
    },
    mounted () {
        this.$store.state.auth.isUserLoggedIn().then( res => {
            if (res) this.doPostLogin()
        })
    },
    methods: {
        doPostLogin () {
            if (this.$route.query.next) {
                this.$router.push(this.$route.query.next)
            } else {
                this.$router.push('/')
            }
        },
        submit () {
            this.submit_disabled = true

            const payload = {
                email: this.email,
                password: this.password
            }

            Request(this, 'POST', this.$store.state.apiendpoints.login, null, payload, {}, false).then(
                res => {
                    this.$store.dispatch('auth/updateUserToken', res.token)
                    this.$store.dispatch('auth/updateAuthenticatedUser', res.user)
                    this.$store.dispatch('auth/updateRole', {role: res.role})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Login Success',
                        text: 'Redirecting.. Please wait..',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    window.location.reload()
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Login Failed',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'API Error',
                            text: 'An Error Occurred. Please try again later.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss">
    .login-logo {
        max-height: 50px; margin-bottom: 30px;
    }
    .login-side-image {
        background-image: url('../../assets/images/pages/21.jpg');;
        background-size: cover;
        background-position: center; border-radius: 1.5rem 0 0 1.5rem;
    }
</style>
